/**
 * PageContacts JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageContacts
 */
export default class PageContacts {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.visibilityClass = 'js-office--visible';
        this.categoriesVisibilityClass = 'js-categories--visible';
        this.categoryActiveClass = 'js-category--active';
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.selectFromDropdown();
        this.showSelectbox();
    }

    /**
     * Cache all needed DOM nodes.
     */
    cache() {

        // Get the container and items for faster DOM manipulations.
        this.$itemsContainer = $( '.js-offices' );
        this.$items          = this.$itemsContainer.find( '.js-office' );

        // Dropdown select box that lists offices
        this.$selectBox = $( '.js-form__custom-select__inner' );

        // Loader icon
        this.$selectLoader = $( '.js-form__custom-select__loader' );

        // Category area
        this.$categoryBox = $( '.js-categories' );
        this.$categories  = this.$categoryBox.find( '.js-category' );

        this.$categoryAllSelection = this.$categoryBox.find( '.js-category-all' );

    }

    /**
     * Show dropdown select box when document is ready.
     * Remove 'u-hide' class which has been automatically set in dust.
     */
    showSelectbox() {
        this.$selectBox.removeClass( 'u-hide' );

        // Hide loader
        this.$selectLoader.addClass( 'u-hide' );
    }

    /**
     * If we come via url with hash, we select the office by slug and load offices and contacts with it.
     */
    selectFromDropdown() {

        // Get current hash if it is set
        if ( location.hash ) {
            this.$currentHash = location.hash.match( /#(\w+)/ )[1];
        }
        const $target = this.$selectBox.find( '.js-office-slug-' + this.$currentHash );
        if ( $target.length ) {
            $target.trigger( 'click' );
            $target.attr( 'checked', true );
        }
    }

    /**
     * Filter contacts when the user selects an office from the custom select box.
     *
     * @param {object} selected The change event or the radio button node.
     */
    filterContacts( selected ) {
        const $target = $( selected.target || selected );
        if ( $target.length ) {
            const officeId = $target.val();

            // First hide all.
            this.hideItems();

            // Remove active classes from every category buttons.
            this.$categories.removeClass( this.categoryActiveClass );

            // Set all selection as selected.
            this.$categoryAllSelection.addClass( this.categoryActiveClass );

            // Get the cards with the correct office id and display them.
            const $officeContacts = this.$itemsContainer.find( '.js-office-' + officeId );
            $officeContacts.addClass( this.visibilityClass );
            this.$categoryBox.addClass( this.categoriesVisibilityClass );

            // Go through category items and set current office id to 'officeid' data attribute.
            this.addOfficeIdtoCategory( officeId );
        } else {
            console.log( 'Something went wrong! Could not find the selected office element.' );
        }

    }

    /**
     * Filter contacts by selected category.
     *
     * @param {object} selected Clicked category button.
     */
    filterByCategory( selected ) {
        const $selectedItem = $( selected.target || selected );

        if ( $selectedItem.length ) {
            const category = $selectedItem.attr( 'data-category' );
            const currentOfficeId = $selectedItem.attr( 'data-officeid' );

            // Remove active classes from every category buttons cause we only show one at a time.
            this.$categories.removeClass( this.categoryActiveClass );

            // Show all contacts if selection is 'all'.
            if ( category === 'all' ) {

                // Get the cards with the correct office id and display them.
                const $officeContacts = this.$itemsContainer.find( '.js-office-' + currentOfficeId );
                $officeContacts.addClass( this.visibilityClass );
                this.$categoryBox.addClass( this.categoriesVisibilityClass );
                this.$categoryAllSelection.addClass( this.categoryActiveClass );

                return;
            }

            // Set current selected category as active.
            $selectedItem.toggleClass( this.categoryActiveClass );

            // First hide all.
            this.hideItems();

            // Show current office info block
            this.showOfficeInfo( currentOfficeId );

            // Show contacts by category
            const $officeContacts = this.$itemsContainer.find( '.js-category-' + category + '.js-office-' + currentOfficeId );
            $officeContacts.addClass( this.visibilityClass );
        } else {
            console.log( 'Something went wrong! Could not find the selected category.' );
        }

        return;
    }

    /**
     * Run everytime user changes office from dropdown selection.
     *
     * Add Office ID to all category selections so we get to show correct contact person(s)
     * when clicked the desired category.
     *
     * @param id
     */
    addOfficeIdtoCategory( id ) {
        this.$categories.attr( 'data-officeid', id );
    }

    /**
     * Use office info box. Run when user filters contacts by category.
     *
     * @param id
     */
    showOfficeInfo( id ) {
        const $currentOfficeInfo = this.$itemsContainer.find( '.js-office-info' + '.js-office-' + id );
        $currentOfficeInfo.addClass( this.visibilityClass );
    }

    hideItems() {
        this.$items.removeClass( this.visibilityClass );
    }
}
